module.exports = __webpack_public_path__ + "static/media/editmode.520f3423.svg";